import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    this.element[this.identifier] = this;
  }

  closeDropdown(event) {
    if (event) {
      if (event.type == 'keyup' && event.which != 27) {
        return;
      }
      if (event.type == 'click' && this.element.contains(event.target)) {
        return;
      }
    }

    this.element.setAttribute('data-active', false);
  }

  toggleDropdown(event) {
    const active = this.element.getAttribute('data-active') == 'true';
    this.element.setAttribute('data-active', !active);
  }
}
